import React from "react";
import { get, filter, includes, size, sortBy } from "lodash";

import { fetchPost } from "../../api/fetch";

import CsvExportDialog from "../Common/CsvExportDialog";

import { eventGroupsData } from "../../constants/eventGroups";

import { fetchCreatedByUsers } from "../../utils/event";
import { formatDate } from "../../utils/date";
import { displayDataCsv } from "../../utils/data";
import { getAttributeValue } from "../../utils/profile";

const ProfileLogCsvExport = (props) => {
  const { profile, columns, lov, language, profileTypesCounts } = props;

  const fetchData = async (filters) => {
    try {
      let body = {
        filter: {
          profile_id: get(profile, ["id"]),
          types: [2, 3, 4, 5],
        },
        pagination: {
          offset: 0,
        },
        data: eventGroupsData,
      };
      if (get(filters, ["startDate"]) && get(filters, ["endDate"])) {
        body.filter.begin = get(filters, ["startDate"]);
        body.filter.end = get(filters, ["endDate"]);
      }
      let data = [];
      let total = 1;
      while (size(data) < total) {
        body.pagination.offset = size(data);
        let res = await fetchPost("new/event_groups", body);
        res.items = await fetchCreatedByUsers(get(res, ["items"]));
        data = [...data, ...res.items];
        total = res.total;
      }
      return data;
    } catch (e) {
      console.log(e);
    }
  };

  const title = get(profile, ["name"]);

  const getSpecificEvents = (item) => {
    const humanEvent = get(
      filter(
        get(item, ["events"]),
        (e) =>
          includes([58, 59, 60, 61], get(e, ["type", "id"])) &&
          get(e, ["active"]) &&
          get(e, ["profile", "type", "id"]) === 1
      ),
      [0]
    );
    const truckEvent = get(
      filter(
        get(item, ["events"]),
        (e) =>
          includes([58, 59, 60, 61], get(e, ["type", "id"])) &&
          get(e, ["active"]) &&
          get(e, ["profile", "type", "id"]) === 2
      ),
      [0]
    );
    const trailerEvents = sortBy(
      filter(
        get(item, ["events"]),
        (e) =>
          includes([58, 59, 60, 61], get(e, ["type", "id"])) &&
          get(e, ["active"]) &&
          get(e, ["profile", "type", "id"]) === 3
      ),
      (e) => getAttributeValue(e, 121)
    );
    const containerEvents = sortBy(
      filter(
        get(item, ["events"]),
        (e) =>
          includes([58, 59, 60, 61], get(e, ["type", "id"])) &&
          get(e, ["active"]) &&
          get(e, ["profile", "type", "id"]) === 4
      ),
      (e) => getAttributeValue(e, 121)
    );
    const mainEvent = truckEvent || humanEvent;
    return {
      mainEvent,
      humanEvent,
      truckEvent,
      trailerEvents,
      containerEvents,
    };
  };

  let dataFunctions = [];
  dataFunctions.push((item) => displayDataCsv(get(item, ["id"])));
  dataFunctions.push((item) =>
    formatDate(
      getAttributeValue(get(getSpecificEvents(item), ["mainEvent"]), 76) ||
        getAttributeValue(get(getSpecificEvents(item), ["mainEvent"]), 77)
    )
  );
  dataFunctions.push((item) =>
    displayDataCsv(
      get(get(getSpecificEvents(item), ["mainEvent"]), ["zone", "site", "name"])
    )
  );
  dataFunctions.push((item) =>
    displayDataCsv(
      get(get(getSpecificEvents(item), ["mainEvent"]), ["zone", "name"])
    )
  );
  dataFunctions.push((item) =>
    displayDataCsv(get(item, ["type", `name_${language}`]))
  );
  dataFunctions.push((item) =>
    displayDataCsv(
      getAttributeValue(
        get(getSpecificEvents(item), ["mainEvent"]),
        105,
        lov,
        language
      )
    )
  );
  dataFunctions.push((item) =>
    displayDataCsv(
      get(get(getSpecificEvents(item), ["humanEvent"]), ["profile", "name"])
    )
  );
  dataFunctions.push((item) =>
    displayDataCsv(
      get(get(getSpecificEvents(item), ["truckEvent"]), ["profile", "name"])
    )
  );
  for (let i = 0; i < profileTypesCounts[3]; i++) {
    dataFunctions.push((item) =>
      displayDataCsv(
        get(get(getSpecificEvents(item), ["trailerEvents", i]), [
          "profile",
          "name",
        ])
      )
    );
  }
  for (let i = 0; i < profileTypesCounts[4]; i++) {
    dataFunctions.push((item) =>
      displayDataCsv(
        get(get(getSpecificEvents(item), ["containerEvents", i]), [
          "profile",
          "name",
        ])
      )
    );
  }
  dataFunctions.push((item) => formatDate(get(item, ["created_on"])));
  dataFunctions.push((item) => displayDataCsv(get(item, ["created_by"])));

  return (
    <CsvExportDialog
      title={title}
      columns={columns}
      fetchData={fetchData}
      dataFunctions={dataFunctions}
    />
  );
};

export default ProfileLogCsvExport;
